<template>
  <div>
      <v-card>
        <v-card-title class="headline lighten-4 justify-center">
          Restricted States Access
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-container fluid>
            <v-row align="center" class="px-2">
              <v-col cols="12" sm="4" md="3">

              </v-col>

              <v-col cols="auto">
                <v-btn text icon @click="refresh" v-if="!isVisible">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
                <div v-if="isVisible" class="load-3 ml-2">
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
              </v-col>

              <v-spacer></v-spacer>

              <v-col cols="12" sm="6" md="5" class="d-flex align-center">
                <v-autocomplete
                  label="Select State to Add"
                  :items="renderedStatesAll"
                  v-model="selectedState"
                  item-value="state"
                  item-text="state"
                  hide-details
                  dense
                  class="mr-2"
                ></v-autocomplete>
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" x-small fab dark color="blue lighten-1" @click="addStateRow"
                           v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>add restricted state</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headersState"
              :items="renderedRestrictedStates"
              :loading="localLoading"
              :search="search"
              item-key="id"
              class="elevation-1 mt-4"
            >
              <template v-slot:item.restricted_states="{ item }">
                {{ item.restricted_states }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn icon color="red" @click="deleteState(item)">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="12" md="3" class="text-center">
              </v-col>
            </v-row>
          </v-container>
    </v-card-text>
  </v-card>
  </div>
</template>

<script>
// @group EditClient
// Client Accounting Information tab for EditClient
import axios from "axios";

export default {
  name: "ClientLinehaulSetting",
  props: {
    // Client Object
    clientInfo: Object,
  },
  data() {
    return {
      items: [
        {text: 'Linehaul Restricted', key: 'linehaul_restricted', type: 'switch'},
      ],
      search:null,
      isVisible:false,
      reload: false,
      localLoading: false,
      headersState: [
        {text: 'ID', align: 'center', sortable: true, value: 'id', width: '100px'},
        {text: 'Restricted State', align: 'center', sortable: true, value: 'restricted_states',width: '100px'},
        {text: 'Action', align: 'center', sortable: false, value: 'actions', width: '120px'},
      ],
      selectedState:null
    }
  },
  methods:{
    addStateRow(){
      let body = {};
      body = {
        client_id: this.clientInfo.id,
        state:this.selectedState
      };
      axios.post(process.env.API_URL + '/linehauls/clientRestrictedStates', body)
        .then((response) => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'create successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'Error: ' + error.response ? error.response.data.error : error);
        });
    },
    deleteState(item){
      axios.delete(process.env.API_URL + '/linehauls/clientRestrictedStates/' + item.id)
        .then((response) => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Delete successful');
        })
        .catch((error) => {
          if(error.response.status === 403){
            this.$store.commit('displaySnackbar', 'Only manager can delete!');
          }
          this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
        });

    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
  },
  computed:{
    renderedStatesAll(){
      if (this.getRestrictedStates === null || this.getRestrictedStates === undefined) {
        return [];
      } else {
        return this.getRestrictedStates.map(depot => {
          return {
            id: depot.id,
            state: depot.restricted_states
          };
        });
      }
    },
    renderedRestrictedStates(){
      if (!this.lineHaulRestrictedStates) return [];
      const validStates = this.renderedStatesAll.map(item => item.state);

      return this.lineHaulRestrictedStates.map(item => {
        const newItem = { ...item };
        if (!validStates.includes(newItem.restricted_states)) {
          newItem.restricted_states = `${newItem.restricted_states} (Invalid)`;
        }
        return newItem;
      });
    }
  },
  asyncComputed: {
    async destinationDepots() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL +'/depots')
          .then((response) => {
            if (response.status === 200) {
              return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
            } else {
              return [];
            }
          })
          .catch((error) => {
            return [];
          });
      }
    },
    async lineHaulRestrictedStates() {
      if (this.reload || !this.reload) {
        this.localLoading = true;

        return await axios.get(process.env.API_URL + '/linehauls/clientRestrictedStates?client_id=' + this.clientInfo.id)
          .then((response) => {
            if (response.status === 200) {
              this.localLoading = false;
              return response.data;
            } else {
              this.localLoading = false;
              return [];
            }
          })
          .catch((error) => {
            this.localLoading = false;
            return [];
          });
      }
    },
    async getRestrictedStates() {
      if (this.reload || !this.reload) {
        this.localLoading = true;

        return await axios.get(process.env.API_URL + '/linehauls/restrictedstates')
          .then((response) => {
            if (response.status === 200) {
              this.localLoading = false;
              return response.data;
            } else {
              this.localLoading = false;
              return [];
            }
          })
          .catch((error) => {
            this.localLoading = false;
            return [];
          });
      }
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientLinehaulSetting.vue